<div class="c-proxy-data-card endpoints_list_wrapper_item">
	<a href="{{jsDelivrLink}}">
		{{#if imgSrc.endsWith('.svg')}}
			<img
				width="{{imgWidth}}"
				height="{{imgHeight}}"
				src="{{@shared.assetsHost}}{{imgSrc}}"
				loading="lazy" />
		{{else}}
			<img
				width="{{imgWidth}}"
				height="{{imgHeight}}"
				src="{{@shared.assetsHost}}{{imgSrc}}"
				srcset="{{@shared.assetsHost}}{{@this.get2xPngSrc(imgSrc)}}"
				loading="lazy" />
		{{/if}}
	</a>
	<p>{{_.formatNumber(hitsTotal)}}</p>
	<span>Requests past {{period}}</span>
	<p>{{_.formatNumber(bandwidthTotal)}} {{bandwidthUnitInternal}}</p>
	<span>Bandwidth past {{period}}</span>
</div>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');

	component.exports = {
		data () {
			return {
				_,
				bandwidthUnit: '',
				hitsTotal: 0,
				bandwidthTotal: 0,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				this.observe('apiName', (apiName) => {
					let period = this.get('period') || 'month';
					let bandwidthUnit = this.get('bandwidthUnit');

					http.fetchCdnOssStats(apiName, period).then(({ hits, bandwidth }) => {
						if (hits.total >= 0) {
							this.animate('hitsTotal', hits.total, { duration: 1000 });
						}

						if (bandwidth.total >= 0) {
							if (!bandwidthUnit) {
								bandwidthUnit = _.findUnitFromNumber(bandwidth.total);
							}

							this.set('bandwidthUnitInternal', bandwidthUnit);
							this.animate('bandwidthTotal', _.convertBytesToUnits(bandwidth.total, bandwidthUnit), { duration: 1000 });
						}
					});
				});
			}
		},
		get2xPngSrc (imgSrc) {
			return imgSrc.replace('.png', '@2x.png 2x');
		},
	};
</script>
